const moment = require('moment');
const { default: AggConstants } = require('../../constants/AggConstants');
const { default: TipoAtributo } = require('../../constants/TipoAtributo');
const FiltroConstants = require('../../constants/FiltroConstants').default;
const Atributos = require('../../common/Atributos');
module.exports = {
    cubo: 'cubo_fichas',
    title: 'Solicitante',
    primeiraConsultaAutomatica: true,
    atributosSelecionados: [
        Atributos.F_SOLICITANTE_ESTADO_SIGLA,
        Atributos.F_SOLICITANTE_CODIGO_IBGE,
        Atributos.F_SOLICITANTE_MUNICIPIO_NOME,
        // Atributos.QNT, // Sempre colocar o último atributo como métrica.
    ],
    nextPage: '/dados-gerais-atendimento',
    backPage: '/series-historicas',
    charts: [
        {
            title: 'ESTADO DO SOLICITANTE',
            description: 'DISTRIBUIÇÃO ESPACIAL DOS CASOS ATENDIDOS POR ESTADOS.',
            type: 'MapChart',
            metaAtributos: [
                {
                    atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
                    rotulo: 'Estado',
                    tipo: TipoAtributo.TEXTO_GEO_UF,
                },
                // {
                //     atributo: Atributos.F_SOLICITANTE_CODIGO_IBGE,
                //     rotulo: 'Cidade',
                //     tipo: TipoAtributo.TEXTO_GEO_COD_IBGE,
                // },
                {
                    atributo: Atributos.QNT,
                    rotulo: 'Quantidade',
                    tipo: TipoAtributo.NUMERICO_INTEIRO,
                },
            ],
            selectDimensions: [Atributos.F_SOLICITANTE_ESTADO_SIGLA, Atributos.QNT],
            filters: [],
            transformations: [],
        },
        {
            title: 'ESTADO DO SOLICITANTE',
            description: 'ESTADO DO SOLICITANTE.',
            type: 'ApexBarChart',
            w: 1,
            selectDimensions: [Atributos.F_SOLICITANTE_ESTADO_SIGLA, Atributos.QNT],
            groupByOp: 'sum',
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_SOLICITANTE_ESTADO_SIGLA],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return '\u200BIgnorado';
                        if (value === 'Ignorado')
                            return '\u200BIgnorado';
                        return value;
                    },
                },
            ],
            uiConfig: {
                enableAnimation: true,
            },
        },
        {
            title: 'MUNICÍPIO DO SOLICITANTE',
            description: 'DISTRIBUIÇÃO ESPACIAL DOS CASOS ATENDIDOS POR MUNICIPIOS.',
            type: 'MapChart',
            metaAtributos: [
                // {
                //     atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
                //     rotulo: 'Estado',
                //     tipo: TipoAtributo.TEXTO_GEO_UF,
                // },
                {
                    atributo: Atributos.F_SOLICITANTE_CODIGO_IBGE,
                    rotulo: 'Cidade',
                    tipo: TipoAtributo.TEXTO_GEO_COD_IBGE,
                },
                {
                    atributo: Atributos.QNT,
                    rotulo: 'Quantidade',
                    tipo: TipoAtributo.NUMERICO_INTEIRO,
                },
            ],
            selectDimensions: [Atributos.F_SOLICITANTE_CODIGO_IBGE, Atributos.QNT],
            filters: [],
            transformations: [],
        },
        {
            title: 'TABELA COM MUNICÍPIOS DO SOLICITANTE',
            description: 'TABELA COM MUNICÍPIOS DO SOLICITANTE.',
            type: 'Pivottable',
            // w: 1,
            h: '29vw',
            headers: ['Estado', 'Município', 'Quantidade'],
            selectDimensions: [Atributos.F_SOLICITANTE_ESTADO_SIGLA, Atributos.F_SOLICITANTE_MUNICIPIO_NOME, Atributos.QNT],
            // aggregatorList: [
            //     {
            //         vals: ['Quantidade'],
            //         aggTitle: 'Quantidade',
            //         aggregatorName: 'Integer Sum',
            //     },
            // ],
            transformations: [],
            aggregatorName: 'Integer Sum',
            vals: ['Quantidade'],
            rows: ['Estado', 'Município'],
            cols: [],
            rowOrder: 'key_a_to_z',
            filters: [],
            transformations: [],
            uiConfig: {
                enableAnimation: true,
            },
        },
    ],
    metaAtributos: [
        {
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            grupo: 'Nome do centro',
            rotulo: 'Nome do centro',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            grupo: 'Ano de atendimento',
            rotulo: 'Ano de atendimento',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            grupo: 'Tipo de Ficha',
            rotulo: 'Tipo de Ficha',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            grupo: 'UF Solicitante',
            rotulo: 'UF Solicitante',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.GRUPO,
            grupo: 'Grupo de agentes',
            rotulo: 'Grupo de agentes',
            tipo: 'TEXTO',
        },
    ],
    preFiltrosServer: [
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            tipoComponente: 'IN_SELECT',
            valor: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'].join(FiltroConstants.SPLIT_VALUES),
        },
    ],
    filtros: [
        {
            key: 1,
            size: 2,
            disabled: true,
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            rotulo: 'Ano do atendimento',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 2,
            size: 2,
            disabled: true,
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            rotulo: 'Tipo de vítima/solicitação',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 3,
            size: 2,
            disabled: false,
            atributo: Atributos.GRUPO,
            rotulo: 'Grupo de agentes',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 4,
            size: 2,
            disabled: true,
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            rotulo: 'UF Solicitante',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 5,
            size: 2,
            disabled: false,
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            rotulo: 'Nome do centro',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
    ],
};
